import React, { useEffect, useState } from "react";
import { Container, Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  ipAddressListAction,
  addIpAddressAction,
  updateIpAddressAction,
  deleteIpAddressAction,
} from "../redux/actions/IpAddress.action";
import DeleteComponent from "../components/Event/DeleteComponent";
import Alert from "../components/Alert";

const IpAddressTable = () => {
  const dispatch = useDispatch();
  const { ipAddressList, error } = useSelector((state) => state.ipAddress);

  const [showDeleteModal, setShowDeleteModal] = useState(undefined);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [search, setSearch] = useState("");
  const [formData, setFormData] = useState({
    ip_address: "",
    location: "",
    city: "",
    country: "",
    id: "",
  });

  // State for managing the alert visibility
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    dispatch(ipAddressListAction());
  }, [dispatch]);

  useEffect(() => {
    if (error && Object.keys(error).length > 0) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Hide alert after 3 seconds
      return () => clearTimeout(timer); // Cleanup timer on component unmount
    }
  }, [error]);

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setIsEditing(false);
    setFormData({
      ip_address: "",
      location: "",
      city: "",
      country: "",
      id: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing) {
      dispatch(updateIpAddressAction(formData)); // Dispatch edit action
    } else {
      dispatch(addIpAddressAction(formData)); // Dispatch create action
    }
    // handleClose(); // Close the modal after submission
  };

  const handleEdit = (ipAddress) => {
    setFormData({
      ip_address: ipAddress.ip_address,
      location: ipAddress.location,
      city: ipAddress.city,
      country: ipAddress.country,
      id: ipAddress._id,
    });
    setIsEditing(true);
    handleShow();
  };

  const handleCancelDelete = () => setShowDeleteModal(undefined);

  const clickCallbackDelete = (list) => setShowDeleteModal(list._id);

  const handleConfirmDelete = () => {
    const reqBody = { ipAddId: showDeleteModal };
    dispatch(deleteIpAddressAction(reqBody));
    handleCancelDelete();
  };

  const searchListedData = ipAddressList.filter((list) =>
    [list.ip_address, list.city, list.country, list.location]?.some((field) =>
      field?.toLowerCase().includes(search?.toLowerCase())
    )
  );

  return (
    <>
      <Container fluid className="px-4">
        <div className="row mt-3">
          <div className="col-12 mb-3 d-flex justify-content-end gap-4">
            <input
              type="text"
              placeholder="Search ..."
              style={{ width: "15%", marginRight: "20px" }}
              onChange={(e) => setSearch(e.target.value)}
              className="form-control form-control-sm me-2"
            />
            <Button
              className="btn btn-primary btn-sm"
              style={{ marginRight: "10px" }}
              onClick={handleShow}
            >
              Create
            </Button>
            <div className="d-flex align-items-center gap-1">
              <h5>Total: {searchListedData?.length}</h5>
            </div>
          </div>
          <div className="col-12">
            <div className="smartTable-tableContainer-ipAddressTable">
              <table className="smartTable-table table table-striped border">
                <thead className="smartTable-thead" style={{position:'sticky', top:'0'}}>
                  <tr>
                    <th>IP Address</th>
                    <th>Location</th>
                    <th>City</th>
                    <th>Country</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {searchListedData?.map((list) => (
                    <tr key={list._id}>
                      <td>{list.ip_address}</td>
                      <td>{list.location}</td>
                      <td>{list.city}</td>
                      <td>{list.country}</td>
                      <td>
                        <div className="d-flex ">
                          <Button
                            className="btn btn-warning btn-sm"
                            onClick={() => handleEdit(list)}
                            style={{ marginRight: "10px" }}
                          >
                            Edit
                          </Button>
                          <Button
                            className="btn btn-danger btn-sm"
                            onClick={() => clickCallbackDelete(list)}
                          >
                            Delete
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>
              {isEditing ? "Edit IP Address" : "Create IP Address"}
            </Modal.Title>
            <button className="btn btn-sm btn-secondary" onClick={handleClose}>X</button>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>IP Address</Form.Label>
                <Form.Control
                  type="text"
                  name="ip_address"
                  value={formData.ip_address}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit">
                {isEditing ? "Update" : "Submit"}
              </Button>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            {showAlert && (
              <div className="form-group">
                <Alert
                  className={
                    error.status === 200
                      ? "alert alert-success"
                      : "alert alert-danger"
                  }
                  showAlert={true}
                  message={error.message}
                />
              </div>
            )}
          </Modal.Footer>
        </Modal>
      </Container>

      <DeleteComponent
        open={showDeleteModal}
        toggleModel={() => setShowDeleteModal(undefined)}
        title={"Are you sure?"}
        question={"You want to delete this IP address?"}
        handleCancelDelete={handleCancelDelete}
        handleConfirmDelete={handleConfirmDelete}
      />
    </>
  );
};

export default IpAddressTable;




